import { type DocNode } from '@atlaskit/adf-schema';
import { type StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const createStoreAssistant = (args: {
	id: string;
	content: string | DocNode;
	agentNamedId?: string;
	agentAuthorId?: string;
	conversationId?: string;
}): StoreAssistant => {
	const authorNamedId = args.agentAuthorId ? undefined : args.agentNamedId;

	return {
		type: 'ASSISTANT',
		content: {
			type: 'FINAL_RESPONSE',
			message: {
				message: {
					role: 'ASSISTANT',
					id: args.id,
					conversation_channel_id: args.conversationId,
					content: args.content,
					time_created: new Date().toISOString(),
					user_ari: 'unknown',
					plugin_invocations: [],
					...(args.agentAuthorId ? { agent_author: { id: args.agentAuthorId } } : {}),
					author: {
						named_id: authorNamedId || 'ai_mate_agent',
						name: 'unknown',
						actor_type: 'AGENT',
						ari: null,
						id: 'unknown',
					},
				},
			},
		},
	};
};
